import { DownloadModalContent } from './downloadModalContent';
import { DownloadModalDescription } from './downloadModalDescription';
import { DownloadModalHeader } from './downloadModalHeader';
import { DownloadModalInstructions } from './downloadModalInstructions';
import { DownloadModalQrCode } from './downloadModalQrCode';
import { DownloadModalRoot } from './downloadModalRoot';
import { DownloadModalStoreBadges } from './downloadModalStoreBadges';
import { DownloadModalTitle } from './downloadModalTitle';

export const DownloadModal = {
  Root: DownloadModalRoot,
  Content: DownloadModalContent,
  Header: DownloadModalHeader,
  Title: DownloadModalTitle,
  Description: DownloadModalDescription,
  Instructions: DownloadModalInstructions,
  QrCode: DownloadModalQrCode,
  StoreBadges: DownloadModalStoreBadges,
} as const;
